import { types } from 'mobx-state-tree';

import { IsoDate, RequestMetadata } from '../../../common/v1';

import { InquiryTypeEnum } from '../definitions/InquiryType';
import OptionalIdentifier from '../types/OptionalIdentifier';
import NumberIdentifier from '../types/NumberIdentifier';

import { SubmissionSourceEnum } from '../definitions/SubmissionSource';
import Mortgage from './Mortgage';
import Provider from './Provider';
import Rate from './Rate';


const Inquiry = types.model('Inquiry', {
    id: OptionalIdentifier,
    date: IsoDate,
    type: types.maybe(InquiryTypeEnum),

    mortgage: types.maybe(Mortgage),
    agent: types.maybe(
        types.model('ComparisonAgent', {
            id: NumberIdentifier, // BBM Agents use integer ids,
            email: types.string,
        }),
    ),

    // TODO: These are optional because older schema are lossy
    rate: types.maybe(Rate),
    provider: types.maybe(Provider),

    brokerage: types.maybe(Provider),

    experiments: types.optional(types.map(types.integer), {}), // map of segments
    source: types.optional(types.string, 'Ratehub'),
    submissionSource: types.maybe(SubmissionSourceEnum),

    request: types.optional(RequestMetadata, {}),
});

export default Inquiry;
